module.exports = {
    doctor_index: "production-v2_doctors_mig",
    insurance_index: "production-v2_insurance_mig",
    facility_index: "production-v2_facilities_mig",
    application_id: "6A1DZXM196",
    api_key: "de9200344cd74e9967ad0df26bb1f2fe",
    clientId: 'widget-indo',
    ipApi: '//api.ipstack.com/check?access_key=2b9d60fc6c9768d46e6d15afdb3357ed',
    api: {
        account: {
            url: "https://service.okadoc.com/account/v1"
        },
        algolia: {
            application_id: "6A1DZXM196",
            api_key: "de9200344cd74e9967ad0df26bb1f2fe",
            url: "https://6a1dzxm196-dsn.algolia.net/1/indexes"
        },
        appointment: {
            url: "https://service.okadoc.com/qms/v1"
        },
        discovery: {
            url: "https://service.okadoc.com/discovery/v2"
        },
        notification: {
            url: "https://service.okadoc.com/notification/v1"
        },
        locale: {
            url: "https://service.okadoc.com/locale/v1"
        },
        qms: {
            url: "https://service.okadoc.com/qms/v1"
        },
    },
    otpTimeout: 60,
    folder: "/antrian/",
    enable_qrcode: ["5783","9329","6150"],
    AVICENNA_FACILITIES: ["6150"],
    OPTIMUS_KEY: '__oPt1Mu5',
    OPTIMUS_VALUE: 'e5232a0d48bb10365e9e7ad20a4135a04d290f5bc6312bc05d0f78d2b4657533',
    STATIC_URL: 'https://storage.googleapis.com/img.okadoc.com/',
    NEW_RELIC_APP: 'd0f55123ab3f540acf6fbea6952eec76601bca83a',
    GA_TRACKING_ID: 'GTM-PT5XQ43',
    BPJS_SEARCH: 'search_patient_by_vclaim',
    // Finger print key bit length
    RSA_KEY_BIT_LENGTH: 2048,
    // RSA public key (pem formated | base64 encoded)
    FINGER_PRINT_PUBLIC_KEY: 'LS0tLS1CRUdJTiBSU0EgUFVCTElDIEtFWS0tLS0tCk1JSUJDZ0tDQVFFQXhxSzRCZUtOeURRMTdRNDdwU1RFTlZNaWJoUEZxSGR6bG1GaWhXbXZ5czN0SlVMODR0WU8Ka1BESm0zSjd2ZlMySFlVQmorVVRSTWxIOU1YTVdVcVUzNDRqbnJYUm16VmhZU1VmQ0pTVkdkRGZKdkdwVkloNgpEL1ZxSUpYaW0xS3lveGVwejJ0ejBjYi9TS1E4NVRVeEF2M3BPTllPT3J4OHE3cmZidTY5MFYyZXFuMmgxSDlICk5pdkxOZndwcklVUWh0WFBhS3BJZWJVcUwxRUtTOFlPQnVSRVUxSkxzdHk0RUY5TENjNWdWRWpuRkcwZU1XbWEKSkVsU0o0UXZkdTNNQTVlQ095d0FWd25PYithdFM0ZzNrNmk5RXA5WEEwU2Y0M0xCZGs5MVpEVUxkVWVrYmxObQpLZ3Rvanh0MGZNU2ppNURIYi8zdEhUZkZwdThMaHNwTi9RSURBUUFCCi0tLS0tRU5EIFJTQSBQVUJMSUMgS0VZLS0tLS0K',
    FINGER_PRINT_ENABLED: false,
    MIDTRANS_URL: 'https://app.midtrans.com/snap/snap.js',
    // MIDTRANS_URL: 'https://app.sandbox.midtrans.com/snap/snap.js',
    MIDTRANS_CLIENT_KEY: 'SB-Mid-client-N2yAiKRjFukQkyIu',
    USE_PAYMENT_REDIRECT: 0,
    SOURCE_FOR_CASH: ['offline', 'online'],
    EXCLUDE_SPECIALITY: [9411],
    KONG_SERVICES_CONFIG: {
      account: {
        enabled: true,
        username: "account",
        consumerSecret: "mxNz5gV6uzjXLaCG2bmzhdeWEAs35AkM"
      },
      appointment: {
        enabled: true,
        username: "appointment",
        consumerSecret: "9Yy6gB2SFW8QMLzzJcya2kneBsnQQ2z2"
      },
      discovery: {
        enabled: true,
        username: "discovery",
        consumerSecret: "Xgm6TJmFdxeCKzvTjZnaq8FK5dwgNyne"
      },
      locale: {
        enabled: true,
        username: "locale",
        consumerSecret: "fn5wBS3Ahk2kgEwMCxYAvYfTMJvSRSJJ"
      },
      notification: {
        enabled: true,
        username: "notification",
        consumerSecret: "Ax8AfhCkt97TLruHweHkhynbCcSDUMna"
      },
      payment: {
        enabled: true,
        username: "payment",
        consumerSecret: "F7Y2WgWa4CwA7nDG3mqmu4rvHPnJa9gV"
      },
      qms: {
        enabled: true,
        username: "qms",
        consumerSecret: "muqK32ss5EKbLh8z2uY7mM8FxhVADWUX"
      },
      tracking: {
        enabled: true,
        username: "tracking",
        consumerSecret: "bf99CpkcpAwGsZTBeZX8YHdKxD9Ur8SY"
      }
    },
    TRACKING_OTEL_COLLECTOR_ENDPOINT:'opentelemetry-collector.monitoring.svc.cluster.local:4317',
	  TRACKING_APM_SERVER_URL:'https://rum.okadoc.net',
  	TRACKING_ENVIRONMENT:'production-v2',
    TRACKING_SERVICE_NAME:'okadoc-fe-kyubi'
};

